"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Validation = /** @class */ (function () {
    function Validation(message, messageDescription, validationSeverity, validationPriority, validatorLabel, relatedMetaFieldIds, validationDisplay, messageData, descriptionMessageData, identityId) {
        this.message = message;
        this.messageDescription = messageDescription;
        this.validationSeverity = validationSeverity;
        this.validationPriority = validationPriority;
        this.validatorLabel = validatorLabel;
        this.relatedMetaFieldIds = relatedMetaFieldIds;
        this.validationDisplay = validationDisplay;
        this.messageData = messageData;
        this.descriptionMessageData = descriptionMessageData;
        this.identityId = identityId;
    }
    Validation.prototype.getMessage = function () {
        return this.message;
    };
    /**
     * @deprecated, please use getRelatedMetaFieldIds() instead
     */
    Validation.prototype.getRelatedMetaFields = function () {
        return this.relatedMetaFieldIds;
    };
    Validation.prototype.getMessageDescription = function () {
        return this.messageDescription;
    };
    Validation.prototype.getRelatedMetaFieldIds = function () {
        return this.relatedMetaFieldIds;
    };
    Validation.prototype.getValidationSeverity = function () {
        return this.validationSeverity;
    };
    Validation.prototype.getValidationPriority = function () {
        return this.validationPriority;
    };
    Validation.prototype.getValidatorLabel = function () {
        return this.validatorLabel;
    };
    Validation.prototype.getValidationDisplay = function () {
        return this.validationDisplay;
    };
    Validation.prototype.getMessageData = function () {
        return this.messageData;
    };
    Validation.prototype.getDescriptionMessageData = function () {
        return this.descriptionMessageData;
    };
    Validation.prototype.getIdentity = function () {
        return this.identityId;
    };
    return Validation;
}());
exports.Validation = Validation;
//# sourceMappingURL=validation.js.map